import { render, staticRenderFns } from "./BatchRequestList.vue?vue&type=template&id=999f575c&scoped=true"
import script from "./BatchRequestList.vue?vue&type=script&lang=ts"
export * from "./BatchRequestList.vue?vue&type=script&lang=ts"
import style0 from "./BatchRequestList.vue?vue&type=style&index=0&id=999f575c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999f575c",
  null
  
)

export default component.exports